import script from "./MegaMeetup.vue?vue&type=script&setup=true&lang=js"
export * from "./MegaMeetup.vue?vue&type=script&setup=true&lang=js"

import "./MegaMeetup.vue?vue&type=style&index=0&id=7d0a3aa0&lang=scss"

const __exports__ = script;

export default __exports__